/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line unused-imports/no-unused-imports
import { jsx } from "@compiled/react";

import { cssMap } from "@atlaskit/css";
import { R300 } from "@atlaskit/theme/colors";

const styles = cssMap({
    container: {
        display: "inline-block",
        flexShrink: 0
    },
    svg: {
        maxWidth: "100%",
        maxHeight: "100%",
        verticalAlign: "bottom",
        pointerEvents: "none"
    }
});

export const PriorityHigh16Icon = ({ label }: { label: string }) => {
    return (
        <span role="img" aria-label={label} css={styles.container}>
            <svg
                width={17}
                height={16}
                viewBox="0 0 17 16"
                fill="none"
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
                css={styles.svg}
            >
                <path
                    d="M9.34379 4.09779L9.41258 4.14609L12.7459 6.81275C13.0334 7.04276 13.08 7.46229 12.85 7.7498C12.6377 8.01519 12.2639 8.07532 11.9815 7.9021L11.913 7.85391L8.99612 5.52L6.07925 7.85391C5.81386 8.06623 5.43597 8.04284 5.1985 7.81185L5.14221 7.7498C4.92989 7.48441 4.95328 7.10652 5.18427 6.86905L5.24632 6.81275L8.57965 4.14609C8.801 3.96901 9.10705 3.95291 9.34379 4.09779Z"
                    fill={R300}
                />
            </svg>
        </span>
    );
};
